module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPreview),
      expression: "!isPreview"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h5', [_vm._v("Automatad Revenue Share")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max_value:100'),
      expression: "'required|max_value:100'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('AutomatadRevenueShare')
    },
    attrs: {
      "data-vv-delay": "1000",
      "name": "AutomatadRevenueShare",
      "type": "text",
      "placeholder": "Enter revenue share in percentage like 15%"
    },
    model: {
      value: (_vm.agreemetformdata.revenue_share),
      callback: function($$v) {
        _vm.$set(_vm.agreemetformdata, "revenue_share", $$v)
      },
      expression: "agreemetformdata.revenue_share"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('AutomatadRevenueShare')),
      expression: "errors.has('AutomatadRevenueShare')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('AutomatadRevenueShare')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h5', [_vm._v("Payment Duration")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('days')
    },
    attrs: {
      "data-vv-delay": "1000",
      "name": "days",
      "type": "text",
      "placeholder": "Enter Number of days like 60 Days"
    },
    model: {
      value: (_vm.agreemetformdata.period_to_send_rev_pub),
      callback: function($$v) {
        _vm.$set(_vm.agreemetformdata, "period_to_send_rev_pub", $$v)
      },
      expression: "agreemetformdata.period_to_send_rev_pub"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('days')),
      expression: "errors.has('days')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('days')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h5', [_vm._v(" Payment Explainer Message ")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('paymentduration')
    },
    attrs: {
      "data-vv-delay": "1000",
      "name": "paymentduration",
      "type": "text",
      "placeholder": "Enter Payment duration tax"
    },
    model: {
      value: (_vm.agreemetformdata.rev_dist_clarity_example),
      callback: function($$v) {
        _vm.$set(_vm.agreemetformdata, "rev_dist_clarity_example", $$v)
      },
      expression: "agreemetformdata.rev_dist_clarity_example"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('paymentduration')),
      expression: "errors.has('paymentduration')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('paymentduration')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h5', [_vm._v(" Termination Duration ")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('terminationduration')
    },
    attrs: {
      "data-vv-delay": "1000",
      "name": "terminationduration",
      "type": "text",
      "placeholder": "Termination Duration like 24 hours"
    },
    model: {
      value: (_vm.agreemetformdata.termination_duration_for_pub),
      callback: function($$v) {
        _vm.$set(_vm.agreemetformdata, "termination_duration_for_pub", $$v)
      },
      expression: "agreemetformdata.termination_duration_for_pub"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('terminationduration')),
      expression: "errors.has('terminationduration')"
    }],
    staticClass: "help is-danger",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.errors.first('terminationduration')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-12",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h5', [_vm._v(" Legal Publisher Name ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "data-vv-delay": "1000",
      "name": "LegalPublisherName",
      "type": "text",
      "placeholder": "Enter Legal Publisher Name"
    },
    model: {
      value: (_vm.agreemetformdata.LegalPublisherName),
      callback: function($$v) {
        _vm.$set(_vm.agreemetformdata, "LegalPublisherName", $$v)
      },
      expression: "agreemetformdata.LegalPublisherName"
    }
  })], 1)])]), _vm._v(" "), _c('agreement', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isPreview),
      expression: "!isPreview"
    }],
    attrs: {
      "revenuShare": _vm.agreemetformdata.revenue_share,
      "periodToSendRevPub": _vm.agreemetformdata.period_to_send_rev_pub,
      "example": _vm.agreemetformdata.rev_dist_clarity_example,
      "terminationDuration": _vm.agreemetformdata.termination_duration_for_pub,
      "LegalPublisherName": _vm.agreemetformdata.LegalPublisherName
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "displaypdf"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px 0 0 0"
    }
  }, [(!_vm.isPreview) ? _c('button', {
    staticClass: "el-button el-button--success",
    on: {
      "click": function($event) {
        return _vm.previewPDF()
      }
    }
  }, [_vm._v("\n\n                                Preview Contract\n                            ")]) : _c('button', {
    staticClass: "el-button el-button--success",
    on: {
      "click": function($event) {
        return _vm.editPDF()
      }
    }
  }, [_vm._v("\n                                Edit PDF\n                            ")]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--success",
    on: {
      "click": function($event) {
        return _vm.downloadcontract()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v("\n                                Download Contract\n                            ")]), _vm._v(" "), (_vm.sendinginvite) ? _c('div', {
    staticClass: "load-4"
  }, [_c('div', {
    staticClass: "ring-1"
  })]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "el-button el-button--danger clearfix",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "to": "/admin/Publishers/"
    }
  }, [_vm._v("\n                                Cancel\n                            ")])], 1)])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Contract")]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "downloadcon"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6bbc5772!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/PaymentForm.vue
// module id = 701
// module chunks = 2